export const SET_PLAYLIST_ITEMS = 'SET_PLAYLIST_ITEMS';
export const SET_IS_PLAYLIST_PREVIEW_ON = 'SET_IS_PLAYLIST_PREVIEW_ON';
export const PLAYLIST_UPDATE = 'PLAYLIST_UPDATE';
export const PLAYLIST_DELETE = 'PLAYLIST_DELETE';
export const GET_PLAYLIST_ITEMS = 'GET_PLAYLIST_ITEMS';
export const PLAYLIST_ITEM_CREATE = 'PLAYLIST_ITEM_CREATE';
export const PLAYLIST_ITEM_UPDATE = 'PLAYLIST_ITEM_UPDATE';
export const PLAYLIST_ITEM_DELETE = 'PLAYLIST_ITEM_DELETE';
